import PropTypes from 'prop-types';
import React from 'react';

const CoverFooter = (props) => {
  const { children } = props;

  return (
    <div className="cover__footer">
      <div className="cover__footer__container">
        {children}
      </div>
    </div>
  );
};

CoverFooter.propTypes = {
  children: PropTypes.node,
};

export default CoverFooter;
